import { createSlice } from '@reduxjs/toolkit';

import { SidebarStateKey } from 'layout/MainLayout/components/Sidebar/store/types';

import type { PayloadAction } from '@reduxjs/toolkit';
import type { SidebarState } from 'layout/MainLayout/components/Sidebar/store/types';

const initialState: SidebarState = {
  [SidebarStateKey.Opened]: undefined,
};

export const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    setSidebarState: (store, action: PayloadAction<boolean>) => {
      store[SidebarStateKey.Opened] = action.payload;
    },
  },
});

export const { actions: sidebarActions, reducer: sidebarReducer } =
  sidebarSlice;
